import { Box, Chip, Skeleton, Tooltip, Typography } from '@mui/material'
import TextNotAssigned from '../../../../../../text/TextNotAssigned'
import ChipStatus from './ChipStatus'
import { getObjectCurriculumElementsDR } from '../../../../../Assessment/utils'
import { useSelector } from 'react-redux'
import TextEllipsis from '../../../../../../text/TextEllipsis'

const TitleClass = ({ classData, results = [], showStudents = true, curriculum }) => {
  const currentCurriculum = useSelector(
    (state) => state?.analytics?.analyticsCurriculum?.datasets?.curriculum || curriculum || {}
  )
  const curriculumElements = getObjectCurriculumElementsDR(
    currentCurriculum?.elements,
    currentCurriculum?.elementsStructure,
    classData?.classCurriculumElements || {}
  )

  return (
    <>
      <Box className=' px-2 py-1 bg-loading2 '>
        <Typography className='text-sm text-primary-foreground'>
          {classData?.classYearLevel?.map((y) => y.name).join(', ')}
        </Typography>
        <Typography className='text-3xl font-bold text-primary-foreground'>{classData.classCode}</Typography>
      </Box>
      <Box className=' px-2 py-1 bg-loading '>
        {showStudents && (
          <Typography className='text-primary-foreground font-bold text-sm opacity-90'>
            #{classData?.classStudents} students
          </Typography>
        )}
        <Typography className='text-2xs text-primary-foreground font-bold'>Teachers: </Typography>
        <div className='flex flex-nowrap gap-1 items-center'>
          {classData?.classTeachers?.map((t) => (
            <Tooltip arrow title={`${t.code} - ${t.firstName} ${t.lastName}`} key={`key-teacher-${t._id}`}>
              <div className='text-xs bg-primary-foreground text-primary px-1  opacity-90 rounded cursor-pointer'>
                {t.lastName}
              </div>
            </Tooltip>
          ))}
        </div>
      </Box>

      <Box className=' px-2 py-1 '>
        <div className='flex gap-1 items-center '>
          <span className='text-sm font-bold text-nowrap'>{curriculumElements?.element?.keyName}</span>
          <TextEllipsis className='text-sm'>
            {curriculumElements?.element?.valueName || <TextNotAssigned />}
          </TextEllipsis>
        </div>
        {curriculumElements?.subElement?.keyName && (
          <div className='flex gap-1 items-center'>
            <span className='text-sm font-bold text-nowrap'>{curriculumElements?.subElement?.keyName}</span>
            <TextEllipsis className='text-sm'>
              {curriculumElements?.subElement?.valueName || <TextNotAssigned />}
            </TextEllipsis>
          </div>
        )}
        {classData?.subjectId?.name && (
          <div className='flex gap-1 items-center'>
            <span className='text-sm font-bold text-nowrap'>Subject</span>
            <TextEllipsis className='text-sm'>
              {classData?.subjectId?.name || <TextNotAssigned />}
            </TextEllipsis>
          </div>
        )}
      </Box>
    </>
  )
}

export default TitleClass
